var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 64,
    viewBox: "0 0 262 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_305)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.785 51.7135C152.252 51.2907 155.532 49.9096 158.258 47.7251L155.133 43.8243C153.133 45.4276 150.724 46.4412 148.18 46.7515C145.636 47.0618 143.055 46.6564 140.729 45.5809C138.402 44.5053 136.42 42.8022 135.008 40.6629C133.595 38.5235 132.807 36.0326 132.732 33.4699C132.657 30.9073 133.297 28.3744 134.582 26.1558C135.866 23.9371 137.744 22.1205 140.004 20.9101C142.263 19.6998 144.815 19.1435 147.374 19.3037C149.932 19.464 152.395 20.3345 154.486 21.8174L157.377 17.7397C154.528 15.7192 151.172 14.5331 147.686 14.3147C144.2 14.0964 140.723 14.8544 137.644 16.5035C134.565 18.1528 132.006 20.6279 130.256 23.6509C128.507 26.6739 127.633 30.1251 127.736 33.6168C127.839 37.1086 128.913 40.5024 130.837 43.4175C132.762 46.3324 135.461 48.653 138.632 50.1184C141.802 51.584 145.318 52.1363 148.785 51.7135ZM153.432 28.2124L137.614 33.0648L153.432 37.9172V28.2124Z",
    fill: "url(#paint0_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.719 51.7135C255.186 51.2907 258.466 49.9096 261.192 47.7251L258.066 43.8243C256.066 45.4276 253.658 46.4412 251.114 46.7515C248.57 47.0618 245.989 46.6564 243.662 45.5809C241.336 44.5053 239.354 42.8022 237.942 40.6629C236.529 38.5235 235.741 36.0326 235.666 33.4699C235.591 30.9073 236.231 28.3744 237.516 26.1558C238.8 23.9371 240.677 22.1205 242.937 20.9101C245.197 19.6998 247.749 19.1435 250.307 19.3037C252.866 19.464 255.329 20.3345 257.42 21.8174L260.311 17.7397C257.462 15.7192 254.105 14.5331 250.62 14.3147C247.134 14.0964 243.656 14.8544 240.577 16.5035C237.498 18.1528 234.94 20.6279 233.19 23.6509C231.44 26.6739 230.567 30.1251 230.67 33.6168C230.772 37.1086 231.847 40.5024 233.771 43.4175C235.696 46.3324 238.395 48.653 241.565 50.1184C244.736 51.584 248.252 52.1363 251.719 51.7135ZM256.365 28.2124L240.548 33.0648L256.365 37.9172V28.2124Z",
    fill: "url(#paint1_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5297 47.7251C27.8042 49.9096 24.5238 51.2907 21.0569 51.7135C17.59 52.1363 14.0738 51.584 10.9034 50.1184C7.73304 48.653 5.03393 46.3324 3.1093 43.4175C1.18467 40.5024 0.110733 37.1085 0.00811202 33.6168C-0.0945091 30.1251 0.77825 26.6739 2.52837 23.6509C4.27848 20.6279 6.83663 18.1528 9.91546 16.5035C12.9943 14.8544 16.472 14.0964 19.9578 14.3147C23.4435 14.5331 26.7994 15.7192 29.6484 17.7397L26.7575 21.8174C24.6666 20.3345 22.2036 19.464 19.6453 19.3037C17.087 19.1435 14.5347 19.6997 12.2751 20.9101C10.0155 22.1205 8.13794 23.937 6.8535 26.1558C5.56906 28.3744 4.92852 30.9073 5.00384 33.4699C5.07915 36.0326 5.86734 38.5235 7.27987 40.6628C8.69243 42.8022 10.6733 44.5053 13.0002 45.5809C15.327 46.6564 17.9076 47.0618 20.452 46.7515C22.9965 46.4412 25.4041 45.4276 27.4043 43.8243L30.5297 47.7251Z",
    fill: "url(#paint2_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.839 51.1863C223.207 50.2648 226.253 48.4221 228.633 45.8652V35.3192H222.773V43.9642C221.469 44.9086 220 45.6154 218.432 46.0439C216.02 46.7039 213.47 46.678 211.071 45.9689C208.672 45.26 206.519 43.8961 204.852 42.0305C203.185 40.1648 202.071 37.8713 201.636 35.4076C201.2 32.9439 201.46 30.4074 202.387 28.0833C203.312 25.7591 204.868 23.7393 206.878 22.2505C208.889 20.7617 211.274 19.8631 213.767 19.6555C216.26 19.448 218.762 19.9397 220.991 21.0754L223.41 16.3252C220.299 14.7395 216.806 14.0529 213.325 14.3428C209.845 14.6326 206.514 15.8873 203.707 17.9658C200.9 20.0444 198.728 22.8646 197.435 26.1096C196.142 29.3546 195.779 32.896 196.387 36.3358C196.995 39.7757 198.55 42.9779 200.877 45.5826C203.204 48.1874 206.212 50.0918 209.561 51.0816C212.911 52.0714 216.47 52.1077 219.839 51.1863Z",
    fill: "url(#paint3_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.188 34.5677C105.188 24.1921 96.7782 15.7809 86.4044 15.7809C76.0306 15.7809 67.6208 24.1921 67.6208 34.5677C67.6208 44.9434 76.0306 53.3545 86.4044 53.3545C91.7156 53.3545 96.5122 51.1497 99.9286 47.6053V53.3545H105.188V34.5677ZM99.9286 34.5677C99.9286 42.1827 94.0177 48.3558 86.4044 48.3558C78.7911 48.3558 72.6187 42.1827 72.6187 34.5677C72.6187 26.9528 78.7911 20.7796 86.4044 20.7796C94.0177 20.7796 99.9286 26.9528 99.9286 34.5677Z",
    fill: "url(#paint4_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.661 63.8752V0H124.92V63.8752H119.661Z",
    fill: "url(#paint5_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.696 0V63.8752H114.955V0H109.696Z",
    fill: "url(#paint6_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.29 14.278V51.8516H167.549V22.9954L189.322 51.7868L189.338 51.7738V51.8516H194.598V14.278H189.338V43.0911L167.549 14.2781L162.29 14.278Z",
    fill: "url(#paint7_linear_325_305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0591 14.278V51.8516H38.3185V35.3192H60.1074V51.8516H65.3668V14.278H60.1074V30.0589H38.3185V14.278H33.0591Z",
    fill: "url(#paint8_linear_325_305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_325_305",
    x1: 158.258,
    y1: 33.4064,
    x2: 127.728,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_325_305",
    x1: 261.192,
    y1: 33.4064,
    x2: 230.662,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_325_305",
    x1: 30.5297,
    y1: 33.4064,
    x2: 2.47109e-8,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_325_305",
    x1: 228.633,
    y1: 33.4064,
    x2: 196.1,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_325_305",
    x1: 105.188,
    y1: 34.9093,
    x2: 67.6208,
    y2: 34.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_325_305",
    x1: 124.92,
    y1: 32.5183,
    x2: 119.661,
    y2: 32.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_325_305",
    x1: 114.955,
    y1: 32.5183,
    x2: 109.696,
    y2: 32.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_325_305",
    x1: 194.598,
    y1: 33.4064,
    x2: 162.29,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_325_305",
    x1: 65.3668,
    y1: 33.4064,
    x2: 33.0591,
    y2: 33.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261.467,
    height: 63.8752,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bf855a83e52f1f3dfe9fe82762788bd.svg";
export { ForwardRef as ReactComponent };